import { Context } from '@nuxt/types'

export default (context: Context) => {
  context.app?.router?.afterEach((to, from) => {})
}
